import { atomWithReset } from "jotai/utils";

export const selectedCurrentComponent = atomWithReset({});
